export { default } from '@shikijs/langs/html'
